import { createRoot } from 'react-dom/client'
import client, { type BasedClient } from '@based/sdk/client'
import basedConfig from '../../based'
import { Provider as BasedClientProvider } from '@based/sdk/react'
import { ThemeProvider } from './providers/useTheme'
import { App } from './app'
import { AppCtxProvider } from './providers/useAppCtx'
import './index.css'

var e = 'Unsupported browser'
if (!Blob.prototype.arrayBuffer) {
  dispatchEvent(new ErrorEvent('error', { message: e }))
  throw Error(e)
}

var ua = navigator.userAgent
function test(f, minV) {
  var idx = ua.indexOf(f)
  if (idx !== -1) {
    var vStr = ua.substring(idx + f.length)
    var match = vStr.match(/^(\d+)/)
    if (match) {
      var v = parseInt(match[1], 10)
      if (v < minV) {
        dispatchEvent(new ErrorEvent('error', { message: e }))
        throw Error(e)
      }
    }
  }
}

test('Firefox/', 100)
test('Chrome/', 95)
test('Edg/', 95)
if (
  ua.indexOf('Safari/') !== -1 &&
  ua.indexOf('Chrome/') === -1 &&
  ua.indexOf('Edg/') === -1
) {
  test('Version/', 14)
}

export const based: BasedClient = client(basedConfig)

const rootElement = document.getElementById('root')!
const root = createRoot(rootElement)

root.render(
  <BasedClientProvider client={based}>
    <ThemeProvider variant="light">
      <AppCtxProvider>
        <App />
      </AppCtxProvider>
    </ThemeProvider>
  </BasedClientProvider>,
)
